import React from 'react';
import divider from '../../assets/divider-img.png';
import e1 from '../../assets/experts/ahmad.png';
import e2 from '../../assets/experts/tariq.png';
import e3 from '../../assets/experts/Arslan.png';
import e4 from '../../assets/experts/Bilal.png';

const HomeExperts = () => {
  const slides = [
    {
      image: e1,
      title: 'Muhammad Ahmad',
      description:
        'Ahmad is a  professional trader and quant developer whose expertise lies at the nexus of technology and finance.',
    },
    {
      image: e2,
      title: 'Muhammad Tariq',
      description:
        'Tariq proficiencies are centered within the realm of Python programming, encompassing its versatile applications in machine learning and data analysis.',
    },
    {
      image: e3,
      title: 'Arsalan Khan',
      description:
        'Arsalan demonstrates proficiency in a diverse range of technical domains, showcasing expertise in Deep Learning, Big Data, Data Analytics, and Quantconnect.',
    },
    {
      image: e4,
      title: 'Bilal',
      description:
        'Bilal is a Full Stack Developer. He is capable of applying logic and reasoning to solve complex problems.',
    },
  ];
  return (
    <div className="home-experts">
      <div className="container">
        <div className="home-experts-wrapper">
          <div className="top-div">
            <h2>Our Experienced Experts For Your support</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              Our team comprises seasoned professionals with deep expertise in
              financial markets and technology. We bring a wealth of knowledge
              to every project we undertake.
            </p>
          </div>
          <div className="expert-wrapper">
            <div className="single-expert">
              {slides.map((slide, index) => (
                <div key={index} className="slide expert">
                  <div className="slide-content expert-content">
                    <img src={slide.image} alt="experts" />
                    <div className="slide-info expert-info">
                      <h3>{slide.title}</h3>
                      <p>{slide.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeExperts;
